import { apiClient } from './axiosInstance';
import { IUpdateUserInfo, IUser } from 'features/user/userTypes';

export const login = async (userData: IUser) => {
  const { data } = await apiClient.post('/login', {
    ...userData,
  });
  return data;
};

export const updateUserData = async (userInfo: IUpdateUserInfo) => {
  return await apiClient.patch('/users', {
    ...userInfo,
  });
};

export const fetchUserData = async () => {
  return await apiClient.get('/users');
};

export const fetchTimeZonesList = async () => {
  return await apiClient.get('/users/time-zone');
};
